import { defineComponent as _defineComponent } from 'vue'
import Modal from "@/components/ui/Modal.vue";
  import { computed } from "vue";
  import type { IBuilderEstimatorFormData } from "@/types/BuilderEstimatorFormData";
  import { BuilderEstimatorSteps } from "@/enums/BuilderEstimatorSteps";
  import BuilderEstimatorQuoterSummaryItem from "./BuilderEstimatorQuoterSummaryItem.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorQuoterSummary',
  props: {
    isOpen: { type: Boolean },
    formData: {},
    totalPrice: {}
  },
  emits: ["update:isOpen"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emit = __emit;

  const summaryItems = computed(() => [
    {
      title: "FLOOR PLAN",
      value:
        props.formData[BuilderEstimatorSteps.SELECT_DESIGN]?.houseDesign?.name,
      price:
        props.formData[BuilderEstimatorSteps.SELECT_DESIGN]?.houseDesign
          ?.basePrice,
      imageUrl:
        props.formData[BuilderEstimatorSteps.SELECT_DESIGN]?.houseDesign
          ?.floorplans[0].url,
      isFloorplan: true,
    },
    {
      title: "FACADE",
      value: props.formData[BuilderEstimatorSteps.SELECT_FACADE]?.facade?.name,
      price: props.formData[BuilderEstimatorSteps.SELECT_FACADE]?.facade?.price,
      imageUrl:
        props.formData[BuilderEstimatorSteps.SELECT_FACADE]?.facade?.url,
    },
    {
      title: "EXTERNAL COLOUR",
      value:
        props.formData[BuilderEstimatorSteps.SELECT_EXTERNAL_COLOURS]
          ?.externalColorScheme?.name,
      price:
        props.formData[BuilderEstimatorSteps.SELECT_EXTERNAL_COLOURS]
          ?.externalColorScheme?.price,
      imageUrl:
        props.formData[BuilderEstimatorSteps.SELECT_EXTERNAL_COLOURS]
          ?.externalColorScheme?.imagesUrls[0],
    },
    {
      title: "INTERNAL COLOUR",
      value:
        props.formData[BuilderEstimatorSteps.SELECT_INTERNAL_COLOURS]
          ?.internalColorScheme?.name,
      price:
        props.formData[BuilderEstimatorSteps.SELECT_INTERNAL_COLOURS]
          ?.internalColorScheme?.price,
      imageUrl:
        props.formData[BuilderEstimatorSteps.SELECT_INTERNAL_COLOURS]
          ?.internalColorScheme?.imagesUrls[0],
    },
    {
      title: "INCLUSIONS",
      value:
        props.formData[BuilderEstimatorSteps.SELECT_INCLUSIONS]?.inclusionPack
          ?.inclusionId?.type,
      price:
        props.formData[BuilderEstimatorSteps.SELECT_INCLUSIONS]?.inclusionPack
          ?.price,
      imageUrl: null,
    },
  ]);

  const optionalUpgradeItems = computed(() => {
    const upgrades =
      props.formData[BuilderEstimatorSteps.OPTIONAL_UPGRADES]?.optionalUpgrades;

    if (!upgrades?.length) {
      return [
        {
          title: "PROMOTIONS / OPTIONAL UPGRADES",
          value: null,
          price: null,
          imageUrl: null,
        },
      ];
    }

    return upgrades.map((upgrade) => ({
      id: upgrade._id,
      title: "PROMOTIONS / OPTIONAL UPGRADES",
      value: upgrade.name,
      price: upgrade.price,
      imageUrl: upgrade.url,
    }));
  });

  const allSummaryItems = computed(() => [
    ...summaryItems.value,
    ...optionalUpgradeItems.value,
  ]);

  const onClose = () => {
    emit("update:isOpen", false);
  };

const __returned__ = { props, emit, summaryItems, optionalUpgradeItems, allSummaryItems, onClose, Modal, computed, get BuilderEstimatorSteps() { return BuilderEstimatorSteps }, BuilderEstimatorQuoterSummaryItem }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})